import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { format, isValid } from 'date-fns';
import { id as localeID } from 'date-fns/locale';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Table } from 'react-bootstrap';
import {
  VoucherContainer,
  VoucherWrapper,
  BtnLink
} from './VoucherElements';
import '../../../style.css';

const Voucher = ({ userData }) => {
  const cookies = new Cookies();
  const token = cookies.get('token');
  const [state, setState] = useState({
    data: [],
    isMobile: window.innerWidth <= 820,
  });

  useEffect(() => {
    fetchData();
    window.addEventListener('resize', handleWindowSizeChange); // Menambahkan event listener untuk menghandle perubahan ukuran layar
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange); // Membersihkan event listener saat komponen dilepas
    };
  }, []);

  const handleWindowSizeChange = () => {
    setState((prev) => ({
      ...prev,
      isMobile: window.innerWidth <= 820 // Mengupdate status isMobile saat terjadi perubahan ukuran layar
    }));
  };

  const fetchData = () => {
    axios
      .get(process.env.REACT_APP_API_BASE_URL + '/voucher', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const sortedData = res.data.content.sort((a, b) => {
          const dateA = new Date(a.createdAt);
          const dateB = new Date(b.createdAt);
          return dateB - dateA;
        });

        const modifiedData = sortedData.map((item) => {
          return {
            ...item,
            createdAt: isValid(new Date(item.createdAt)) ? format(new Date(item.createdAt), 'dd MMMM yyyy', { locale: localeID }) : '',
          };
        });
        setState((prev) => ({
          ...prev,
          data: modifiedData
        }));
      })
      .catch((error) => console.log(error.response.data.message));
  };

  const exportToExcel = () => {
    axios
      .get(process.env.REACT_APP_API_BASE_URL + '/voucher', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const data = res.data.content;
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Voucher');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'voucher_claim.xlsx');
      })
      .catch((error) => console.log(error));
  };

  return (
    <VoucherContainer id="voucher">
      {!state.isMobile && ( // Hanya menampilkan tabel dan pagination jika bukan tampilan mobile
        <>
          <VoucherWrapper>
            <BtnLink to="#" onClick={exportToExcel}>Download Laporan Klaim Voucher</BtnLink>
            <Table striped bordered hover className="voucher">
              <thead>
                <tr>
                  <th>Nomor Peserta</th>
                  <th>Kode Voucher</th>
                  <th>Nominal</th>
                  <th>Tanggal Klaim</th>
                </tr>
              </thead>
              <tbody>
                {state.data.map((item) => (
                  <tr key={item.id}>
                    <td>{item.no_peserta}</td>
                    <td>{item.code}</td>
                    <td>{item.nominal}</td>
                    <td>{item.createdAt}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </VoucherWrapper>
        </>
      )}
      {state.isMobile && ( // Hanya menampilkan nama dan status jika tampilan mobile
        <>
          <VoucherWrapper>
            <Table striped bordered hover className="registrasi">
              <thead>
                <tr>
                  <th>Nomor Peserta</th>
                  <th>Kode Voucher</th>
                  <th>Nominal</th>
                </tr>
              </thead>
              <tbody>
                {state.data.map((item) => (
                  <tr key={item.id}>
                    <td>{item.no_peserta}</td>
                    <td>{item.code}</td>
                    <td>{item.nominal}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </VoucherWrapper>
        </>
      )}
    </VoucherContainer>
  );
};

export default Voucher;
